const prefSwitchToCandidate = (switch_to_candidate = false, action) => {
    switch (action.type) {
        case "ADD_SWITCH_TO_CANDIDATE":
            return action.payload;
        default:
            return switch_to_candidate;
    }
};

export default prefSwitchToCandidate;